import { install, gtag, initDataLayer } from 'ga-gtag'
import { detectWebViewModeEnv } from '@/stores/webViewMode'

export const toGaIdSetting = (
  gaIdsRaw: string | undefined,
  params: Record<string, string>,
  // WebView（アプリ内の工事作成画面）では追加プロパティを設定しない。プロパティを増やすと
  // 1操作ごとに送信タグが増え、操作レスポンスが悪化するため（#24514）
  mainAccountOnly = false
): {
  mainAccount: { tagId: string; config: Record<string, string> };
  additionalAccounts: { tagId: string }[];
  enabled: boolean;
} => {
  const gaIds = (gaIdsRaw || '')
    .split(',')
    .map(id => id.trim())
    .filter(id => id.length > 0)

  const [mainId = '', ...restIds] = gaIds
  const mainAccount = { tagId: mainId, config: params }
  const additionalAccounts = mainAccountOnly ? [] : restIds.map(tagId => ({ tagId }))
  const enabled = gaIds.length > 0

  return { mainAccount, additionalAccounts, enabled }
}

export const getCookieParams = (noSecureCookieEnv: string | undefined): Record<string, string> => {
  const secureCookie = (noSecureCookieEnv !== 'true')
  return secureCookie ? { cookie_flags: 'secure' } : {}
}

export const initGaGtag = () => {
  // enabled=falseでもdataLayerは初期化しておく
  initDataLayer()

  const gaIdsRaw = import.meta.env.VITE_APP_GA_IDS
  const noSecureCookieEnv = import.meta.env.VITE_APP_NO_SECURE_COOKIE
  const params = getCookieParams(noSecureCookieEnv)

  const { mainAccount, additionalAccounts, enabled } = toGaIdSetting(gaIdsRaw, params, detectWebViewModeEnv())

  if (!enabled) return

  try {
    // ga-gtagでメインアカウントを初期化（スクリプト読み込み + 設定）
    install(mainAccount.tagId, mainAccount.config)

    // 追加アカウントを設定
    additionalAccounts.forEach(account => {
      gtag('config', account.tagId)
    })

    console.info('Google Analytics initialized with ga-gtag')
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error)
  }
}
